import React from "react";
import { useUser } from "../UserContext"; // Adjust the import path as necessary
import AnalyticsBrand from "./Brand/AnalyticsBrand";
import AnalyticsAccount from "./Account/AnalyticsAccount";
import AnalyticsAgency from "./Agency/AnalyticsAgency";

const AnalyticsRouter: React.FC = () => {
  const { currentUser } = useUser(); // Assuming currentUser is available in UserContext

  return (
    <>
      {currentUser?.role === "Brand" || currentUser?.role === "Supplier" ? (
        <AnalyticsBrand />
      ) : currentUser?.role === "Account" || currentUser?.role === "Owner" ? (
        <AnalyticsAccount />
      ) : currentUser?.role === "Agency" ? (
        <AnalyticsAgency />
      ) : (
        <div>Please log in or access a different route.</div>
      )}
    </>
  );
};

export default AnalyticsRouter;
